import * as React from "react";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { Grid, Switch, Tooltip, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  getSendingFullDocument,
  getuser,
  sendingfulldocument,
} from "../../redux/slices/userSlice";
import SearchIcon from "@mui/icons-material/Search";
interface AccordionInterface {
  title: string;
  children: React.ReactElement<any, any>;
  addbutton: React.ReactElement<any, any>;
  height: number;
  showingLoaders?: boolean;
  showSearch: boolean;
  onSearchClick: any;
}

export default function AccordionUsage({
  title,
  children,
  addbutton,
  height,
  showingLoaders = false,
  showSearch,
  onSearchClick
}: AccordionInterface) {
  // const [open, setOpen] = React.useState(true);

  // const handleClick = () => {
  //   setOpen(!open);
  // };

  return (
    <List component="nav" aria-labelledby="nested-list-subheader">
      <ListItemButton sx={{pb:0}}>
        <ListItemText
          primary={title}
          sx={{
            pb: 0.2,
            borderBottom: "1px solid rgba(0,0,0,.1)",
          }}
        />
        {showSearch && (
          <SearchIcon
            color="primary"
            onClick={onSearchClick}
            fontSize="small"
            sx={{ mr: "3px" }}
          />
        )}
        <Tooltip title="Add file">{addbutton}</Tooltip>

        {/* {open ? <ExpandLess /> : <ExpandMore />} */}
      </ListItemButton>
      {/* <Collapse in={open} timeout="auto" unmountOnExit> */}
      <List
        sx={{
          maxHeight: showingLoaders ? height + "vh" : "auto",
          minHeight: showingLoaders ? "auto" : height + "vh",
          overflow: "auto",
        }}
        component="div"
        disablePadding
      >
        {children}
      </List>
      {/* </Collapse> */}
    </List>
  );
}
